import React, { lazy } from 'react';

import AuthLayout from '../layout/auth';
import Loadable from '../components/Loadable';

const AuthLogin = Loadable(lazy(() => import('../pages/auth/signin')));

const authRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <AuthLayout />,
      children: [
        {
          path: '',
          element: <AuthLogin />,
        },
        {
          path: 'signin',
          element: <AuthLogin />,
        },
      ],
    },
  ],
};

export default authRoutes;
